module.exports = __webpack_public_path__ + "img/연남동 피자.8b684de8.png";